/**
 * Special Equipment Section Component
 * Handles operational equipment selection
 */

import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Switch } from '../../../../../catalyst/checkbox';
import WizardSection from '../../WizardSection';

const SpecialEquipmentSection = ({ draftConfig, updateConfig, specialEquipment }) => {
  return (
    <WizardSection.Card>
      <WizardSection.Header>
        <div className="flex items-center">
          <AlertCircle className="h-5 w-5 text-amber-500 mr-2" />
          Special Equipment (Operational Requirements)
        </div>
      </WizardSection.Header>
      <p className="text-sm text-gray-600 mb-4">
        Select operational equipment that affects training, maintenance, and familiarisation requirements.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {specialEquipment.map(equipment => (
          <label 
            key={equipment.value} 
            className="flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
          >
            <Switch
              checked={draftConfig.specialEquipment?.includes(equipment.value) || false}
              onChange={(checked) => {
                const currentEq = draftConfig.specialEquipment || [];
                const newEq = checked 
                  ? [...currentEq, equipment.value]
                  : currentEq.filter(e => e !== equipment.value);
                updateConfig({ specialEquipment: newEq });
              }}
              className="mt-0.5"
            />
            <div className="flex-1">
              <p className="font-medium text-gray-900 text-sm">{equipment.label}</p>
              <p className="text-xs text-gray-600 mt-1">{equipment.help}</p>
              <p className="text-xs text-gray-500 mt-1 font-medium">{equipment.reference}</p>
            </div>
          </label>
        ))}
      </div>
    </WizardSection.Card>
  );
};

export default SpecialEquipmentSection;